import styled from 'styled-components'

export const BarTrack = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  height: 15px;
  width: 100%;
  border-radius: 999px;
  background: #e5e7eb;
  overflow: hidden;
`

export const BarSegment = styled.div`
  height: 100%;
  flex-shrink: 0;
  width: ${({ $widthPercent }) => $widthPercent}%;
  background: ${({ color }) => color};
`